import request from "@/common/request";
import { MetaDiaria } from "@/models/MetaDiaria";

const PATH = "/nova-meta-diaria"

export const get = (id: string): Promise<MetaDiaria> =>
	request.get(`${PATH}/${id}`)

export const findByUserAndRange = (
	metaId: string, userId: string, start: string, end: string,
): Promise<MetaDiaria[]> =>
	request.get(`${PATH}/vendedor`, {
		params: { metaId, userId, start, end },
	})

export const getValorTotalMetasDiarias = (
	metaId: string, start: string, end: string,
): Promise<number> =>
	request.get(`${PATH}/valor-meta`, {
		params: { metaId, start, end },
	})

export const create = (metaDiaria: MetaDiaria): Promise<MetaDiaria> =>
	request.post(`${PATH}`, metaDiaria)

export const update = (metaDiaria: MetaDiaria): Promise<MetaDiaria> =>
	request.put(`${PATH}/${metaDiaria.id}`, metaDiaria)

export const deleteUsuarioMeta = (metaId: string, userId: string): Promise<void> =>
	request.delete(`${PATH}/delete/usuario`, {
		params: { metaId, userId },
	})

export const deleteMeta = (metaId: string): Promise<void> =>
	request.delete(`${PATH}/delete/meta`, {
		params: { metaId },
	})

export const importarMetasDiarias = async (metaId: string, mes: number, ano: number, urlDoArquivo: string): Promise<void> =>
	request.post(`${PATH}/importar/${metaId}?mes=${mes}&ano=${ano}&urlDoArquivo=${urlDoArquivo}`)